import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/BreadCrumb/BreadCrumb";
import Spinner from "../../../Components/Spinner/Spinner";
import axios from "axios";
import baseUrl from "../../../baseUrl";
import { useParams } from "react-router-dom";
import moment from "moment";
import Question from "../../../Components/Admin/Question/Question";

const ExamDetails = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));

  const { id } = useParams();

  const [exam, setExam] = useState([]);
  const [loading, setLoading] = useState(false);

  //   list the div of the single exam
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/get-exam-details/${id}`, {
        headers: { Authorization: `Bearer ${adminToken}` },
      })
      .then((res) => {
        if (res.data.success === true) {
          setExam(res.data.exam);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      {loading && <Spinner />}

      <div>
        <section className="text-gray-700">
          <h3 className="text-gray-700 text-3xl font-bold">Exam div</h3>
          <hr />
          <BreadCrumb
            textOne="Dashboard"
            linkOne="/admin/dashboard"
            textTwo="Exams"
            linkTwo="/admin/exams"
            textThree="Exam div"
          />

          <div className="container px-5 py-5 mx-auto">
            <div className="text-center mb-10">
              <h1 className="sm:text-3xl text-2xl font-medium text-center title-font text-gray-900 mb-4">
                Exam Title: {exam.examTitle}
              </h1>
              <h1 className="sm:text-2xl text-xl font-medium text-center title-font text-gray-900 mb-4">
                Subject:{exam.examSubject}
              </h1>
            </div>
            <div className="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
              <div className="w-full lg:w-1/2 px-4 py-2">
                <div className="mb-4 cursor-pointer">
                  <div className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                    Exam Code
                  </div>
                  <span className="ml-4">{exam.examCode}</span>
                </div>
                <div className="mb-4 cursor-pointer">
                  <div className="font-semibold bg-gray-200 rounded-md py-2 px-4">
                    Exam Center
                  </div>
                  <span className="ml-4">{exam.examCenter}</span>
                </div>
                <div className="mb-4 cursor-pointer">
                  <div className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                    Exam Start At
                  </div>
                  <span className="ml-4">
                    {moment(exam.examStartAt).format("MMMM Do YYYY, h:mm:ss a")}
                  </span>
                </div>
              </div>
              <div className="w-full lg:w-1/2 px-4 py-2">
                <div className="mb-4 cursor-pointer">
                  <div className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                    Exam Duration
                  </div>
                  <span className="ml-4">{exam.examDuration} Min</span>
                </div>
                <div className="mb-4 cursor-pointer">
                  <div className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                    Exam Status
                  </div>
                  <span className="ml-4">{exam.examStatus}</span>
                </div>
                <div className="mb-4 cursor-pointer">
                  <div className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                    Exam End At
                  </div>
                  <span className="ml-4">
                    {moment(exam.examEndAt).format("MMMM Do YYYY, h:mm:ss a")}
                  </span>
                </div>
              </div>
            </div>
            <div className="text-center mb-20">
              <h1 className=" font-bold text-3xl leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
                Instruction
              </h1>
              <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
                {exam.examInstruction}
              </p>
            </div>
          </div>
        </section>
      </div>
      <hr />
      <Question examTitle={exam.examTitle} />
    </>
  );
};

export default ExamDetails;
